import {parse as parseQueryString} from 'query-string'
import {pipe, prop} from 'ramda'

const TOKEN_KEY = 'token'

export const getTokenQuery = pipe(
  parseQueryString,
  prop(TOKEN_KEY),
)

export const getSessionToken = () => sessionStorage.getItem(TOKEN_KEY)
export const storeSessionToken = (token: string) => sessionStorage.setItem(TOKEN_KEY, token)
export const clearSessionToken = () => sessionStorage.removeItem(TOKEN_KEY)



// WEBPACK FOOTER //
// ./src/token.js